var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Avatar, Skeleton } from '@mui/material';
import React from 'react';
import { getProducerAvatar, setProducerAvatar } from '../../localStorage';
export default function ProducerImageAvatar(_a) {
    var _this = this;
    var offerList = _a.offerList, avatarProps = __rest(_a, ["offerList"]);
    var _b = React.useState(''), path = _b[0], setPath = _b[1];
    var _c = React.useState(true), loading = _c[0], setLoading = _c[1];
    React.useEffect(function () {
        if (!offerList.storyUrls.ja && !offerList.avatarUrl)
            return;
        var canceled = false;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var content, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!offerList.avatarUrl) return [3 /*break*/, 1];
                        _a = offerList.avatarUrl;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, fetchOgImage(offerList.storyUrls.ja)];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        content = _a;
                        if (!content || canceled) {
                            setLoading(false);
                            return [2 /*return*/];
                        }
                        setPath(content);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [offerList.storyUrls.ja]);
    return (React.createElement(React.Fragment, null, loading ? (React.createElement(Skeleton, { variant: "circular" },
        React.createElement(Avatar, __assign({ sx: {
                height: {
                    xs: '40px',
                    md: '48px',
                },
                width: {
                    xs: '40px',
                    md: '48px',
                },
            } }, avatarProps)))) : (React.createElement(Avatar, __assign({ src: path, sx: {
            height: {
                xs: '40px',
                md: '48px',
            },
            width: {
                xs: '40px',
                md: '48px',
            },
        } }, avatarProps)))));
}
var fetchOgImage = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var cache, response, text, el, headEls, path_1, _e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                cache = getProducerAvatar(url);
                if (cache)
                    return [2 /*return*/, cache];
                return [4 /*yield*/, fetch(url)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.text()];
            case 2:
                text = _a.sent();
                el = new DOMParser().parseFromString(text, 'text/html');
                headEls = el.head.children;
                path_1 = '';
                Array.from(headEls).forEach(function (v) {
                    var prop = v.getAttribute('property');
                    var content = v.getAttribute('content');
                    if (prop && content && prop === 'og:image')
                        path_1 = content;
                });
                if (path_1)
                    setProducerAvatar(url, path_1);
                return [2 /*return*/, path_1];
            case 3:
                _e_1 = _a.sent();
                return [2 /*return*/, ''];
            case 4: return [2 /*return*/];
        }
    });
}); };
